export var ZINDEX_SPINNER = 9000;
export var ZINDEX_MODAL = 5000;
export var ZINDEX_DRAWER = 5000;
export var ZINDEX_OVERLAY = 5000;